export default __webpack_public_path__ + "static/media/elegantChair.37279a08.png";